export const mockCost = {
  id: "cost-01",
  name: "Cost Overview",
  totalCost: 123456,
  plannedCost: 100000,
  actualCost: 120000,
  remainingCost: 23456,
  completionRate: 85,
  variance: 5000,
  costReadyForApproval: 20000
};